import type { ChannelStatus, DesiredState, EffectiveState, EnrollmentStatus } from './types';

export const DESIRED_LABEL: Record<DesiredState, string> = {
  running: 'Souhaité : actif',
  stopped: 'Souhaité : arrêté',
};

export const EFFECTIVE_LABEL: Record<EffectiveState, string> = {
  running: 'Effectif : sain',
  degraded: 'Effectif : dégradé',
  stalled: 'Effectif : bloqué',
  stopped: 'Effectif : arrêté',
};

export const CHANNEL_LABEL: Record<ChannelStatus, string> = {
  active: 'actif',
  needs_reauth: 'réauth requise',
  revoked: 'révoqué',
};

export const ENROLLMENT_LABEL: Record<EnrollmentStatus, string> = {
  active: 'actif',
  reserved: 'réservé',
  consumed: 'consommé',
  revoked: 'révoqué',
  expired: 'expiré',
};

export const RUNTIME_LABEL: Record<string, string> = {
  enabled: 'actif',
  grant_pending: 'scope manquant',
  failed: 'échec',
  pending: 'en attente',
  disabled: 'désactivé',
  revoked: 'révoqué',
};

export const FEATURE_LABELS: Record<string, string> = {
  'chat.messaging': 'Messagerie de chat',
  'stream.lifecycle': 'Cycle de vie du stream',
  'channel.profile': 'Profil de la chaîne',
  'moderation.safety': 'Modération',
  'community.relationships': 'Communauté',
  'engagement.channel_points': 'Points de chaîne',
  'engagement.polls': 'Sondages',
  'engagement.predictions': 'Pronostics',
  'monetization.moments': 'Moments',
  'monetization.ads': 'Publicités',
  'content.media': 'Contenu',
  'collaboration.guest_star': 'Guest Star',
};

export function runtimeLabel(status: string | null | undefined): string {
  if (!status) return 'absent';
  return RUNTIME_LABEL[status] ?? status;
}
